import {
	Directive,
	Input,
	forwardRef
} from '@angular/core';
import { isEqual } from 'underscore';
import { NG_ASYNC_VALIDATORS, AbstractControl, ValidationErrors, AsyncValidator, NgModel } from '@angular/forms';
import { noop } from 'rev-shared/util';

const CacheTimeMs = 500;

@Directive({
	selector: '[shortcutNameAsyncValidator]',
	providers: [{
		provide: NG_ASYNC_VALIDATORS,
		useExisting: forwardRef(() => ShortcutNameAsyncValidatorDirective),
		multi: true
	}],
	standalone: false
})
export class ShortcutNameAsyncValidatorDirective implements AsyncValidator {
	@Input() public shortcutNameAsyncValidator: any;
	@Input() public validatorData: any[];

	private currentParams: any;
	private currentResult: Promise<ValidationErrors>;

	public validate(control: AbstractControl): Promise<ValidationErrors | null> {
		if (!control?.value) {
			return Promise.resolve(null);
		}
		const params = [control.value, ...this.validatorData].filter(Boolean);
		if(isEqual(params, this.currentParams)) {
			return this.currentResult;
		}

		this.currentParams = params;
		this.currentResult = this.shortcutNameAsyncValidator(control.value);

		return this.currentResult
			.then(res => {
				return new Promise(resolve => {
					setTimeout(() => resolve(res), CacheTimeMs);
				});
			});
	}
}
